import { useState } from "react";
import { useTranslation } from "react-i18next";
import RebarInfoTable from "./RebarInfoTable";
import proImg from "../../assets/images/misc/steel-g.webp";

function RebarTab() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<"products" | "capacity">("products");

  const productPoints = t("Tab_content_for_Products_points", { returnObjects: true }) as string[];
  const capacityPoints = t("Tab_content_for_Productive_capacity_points", { returnObjects: true }) as string[];

  return (
    <section className="product-tab-section">
      <div className="container">
        <span className="page-section-label">{t("Steel Rebar")}</span>
        <h2 className="inner-page-heading">{t("Steel Rebar")}</h2>
        <p className="product-tab-intro">{t("rebar-info")}</p>

        {/* Tab navigation */}
        <div className="product-tabs-nav">
          <button
            type="button"
            className={`product-tab-btn${activeTab === "products" ? " active" : ""}`}
            onClick={() => setActiveTab("products")}
          >
            {t("Products")}
          </button>
          <button
            type="button"
            className={`product-tab-btn${activeTab === "capacity" ? " active" : ""}`}
            onClick={() => setActiveTab("capacity")}
          >
            {t("Productive Capacity")}
          </button>
        </div>

        {/* Products panel */}
        <div className={`product-tab-panel${activeTab === "products" ? " active" : ""}`}>
          <p className="product-tab-intro">{t("Tab_content_for_Products_intro")}</p>
          <ol className="product-tab-list">
            {productPoints.map((point, i) => (
              <li key={i}>{point}</li>
            ))}
          </ol>
          <p className="product-tab-intro">{t("Tab_content_for_Products_end")}</p>
          <RebarInfoTable />
          <img src={proImg} alt="Steel Rebar" className="product-tab-img" />
        </div>

        {/* Productive Capacity panel */}
        <div className={`product-tab-panel${activeTab === "capacity" ? " active" : ""}`}>
          <p className="product-tab-intro">{t("Tab_content_for_Productive_capacity_intro")}</p>
          <ol className="product-tab-list">
            {capacityPoints.map((point, i) => (
              <li key={i}>{point}</li>
            ))}
          </ol>
          <img src={proImg} alt="Steel Rebar" className="product-tab-img" />
        </div>
      </div>
    </section>
  );
}

export default RebarTab;
